interface ButtonCustomProps {
  type?: "button" | "submit" | "reset";
  className?: string;
  text?: string;
  onClick?: () => void;
  icon?: React.ReactNode;
  disabled?: boolean;
  isIcon?: boolean;
}

export const ButtonCustom = ({
  type = "button",
  className,
  onClick,
  text = "Thêm mới",
  icon,
  disabled = false,
  isIcon = false,
}: ButtonCustomProps) => {
  return (
    <button
      data-testid="button-custom"
      disabled={disabled}
      type={type}
      className={`btn ${className ??
        "bg-[#E3ECF5] text-[#1462B0] hover:bg-[#1462B0] hover:text-white"
        } uppercase font-bold `}
      onClick={onClick}
    >
      {icon && <span className={isIcon ? "" : "ltr:mr-2 rtl:ml-2"}>{icon}</span>}
      {text}
    </button>
  );
};
